import React from 'react';
import { cn } from '../lib/utils';

const ActivityItem = ({
  icon: IconComponent,
  title,
  titleContent,
  titleClassName,
  rowClassName,
  subtitle,
  subtitleFirst = false,
  subtitleTooltip,
  badge,
  amount,
  badgeColor = 'blue',
}) => {
  const badgeClass = {
    blue: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300',
    green: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300',
    yellow: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300',
    red: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300',
    gray: 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300',
  }[badgeColor] || 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300';

  return (
    <div className={cn('px-4 py-4 sm:px-6', rowClassName)}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {IconComponent && (
            <div className="h-10 w-10 shrink-0 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-lg">
              <IconComponent className="h-5 w-5 text-gray-600 dark:text-gray-400" aria-hidden />
            </div>
          )}
          <div className={IconComponent ? 'ml-4' : ''}>
            {subtitleFirst ? (
              <div className="flex flex-wrap items-baseline gap-x-1.5 gap-y-0 min-w-0">
                {subtitle && (
                  <span
                    className="text-xs text-gray-500 dark:text-gray-400 shrink-0"
                    title={subtitleTooltip || undefined}
                  >
                    {subtitle}
                  </span>
                )}
                <p
                  className={cn(
                    'font-medium text-gray-900 dark:text-gray-100 min-w-0',
                    titleClassName ?? 'text-sm'
                  )}
                >
                  {titleContent ?? title}
                </p>
              </div>
            ) : (
              <>
                <p
                  className={cn(
                    'font-medium text-gray-900 dark:text-gray-100',
                    titleClassName ?? 'text-sm'
                  )}
                >
                  {titleContent ?? title}
                </p>
                {subtitle && (
                  <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{subtitle}</p>
                )}
              </>
            )}
          </div>
          {badge && (
            <span className={`ml-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badgeClass}`}>
              {badge}
            </span>
          )}
        </div>
        {amount !== undefined && (
          <div className="text-right">
            <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">{amount}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityItem;


